import React, {useState, useCallback} from 'react';
import { ButtonGroup } from 'app/src/elements/buttons';
import { Button } from './elements';
import { View, Text } from 'react-native';
import colors from '../../styles/colors';
import { dollars, numberWithDelimiter } from 'app/src/utils/stringHelpers';
import WinnerInfoAlert from './WinnerInfoAlert';

const ConfirmSoldAlert = (props) => {
  const {highBid, highBidDetails, saleAsset,
    reservePrice, belowReserve, setShowModal, bidWon, setConfirmed
  } = props;
console.log('highbid in confirm', highBid)
console.log('setConfirmed', setConfirmed)
  const [showWinnerInfoAlert, setShowWinnerInfoAlert] = useState(false);

  const handleConfirm = () => {
    // bidWon({ variables: { saleAssetId: saleAsset.id }});
    // setShowModal(false);
    setConfirmed(true);
  };


  const confirmation =
    `Last bid of ${dollars(highBid)} is below reserve ` +
    `of ${dollars(reservePrice)}. ` +
    'Do you really want to sell asset?';

  // if (window.confirm(confirmation)) {
  // proceed = true;
  // }

  return(
    <>
      <View style={{marginBottom: '20px'}}>
        <Text>{confirmation}</Text>
      </View>
      <ButtonGroup style={{marginBottom: '20px'}}>
        <Button
          title="Cancel"
          color={colors.elRed}
          onPress={() => setShowModal(false)}
        />
        <Button
          title="Confirm"
          color={colors.biddingAcceptGreen}
          onPress={() => handleConfirm()}
        />
      </ButtonGroup>
    </>
  )
}

export default ConfirmSoldAlert;